import { PromotionRepository } from '../../domain/repositories/promotion.repository';
import { PromotionEntity } from '../../domain/entities/promotion.entity';

export class GetPromotionByIdUseCase {
  constructor(private readonly promotionRepository: PromotionRepository) {}

  async execute(id: string): Promise<PromotionEntity | null> {
    return this.promotionRepository.getPromotionById(id);
  }
}
